import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type Props = {
  id: string;
  name: string;
  email: string;
};

const identify = ({ id, name, email }: Props) => {
  if (window.analytics) {
    window.analytics.identify(id, {
      name,
      email,
    });
  }
};

export const identifyUnknown = () => {
  if (window.analytics) {
    window.analytics.identify('Unknown');
  }
};

export const Segment = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.analytics) {
      window.analytics.page();
    }
  }, [pathname]);

  return null;
};

export default identify;
